import { Component, Input } from '@angular/core';
import { PlantCapacities, PlantCapacity, PlantCapacityPeriod } from '../types';

@Component({
  selector: 'dashboard-plant-capacities',
  templateUrl: './capacities.component.html',
  styleUrls: ['./capacities.component.scss']
})
export class DashboardPlantCapacitiesComponent {
  @Input() capacities: PlantCapacities = {
    onCall: { orderCount: 0, amount: 0 },
    plants: []
  };

  get periodHeaders(): PlantCapacityPeriod[] {
    const firstPlant = this.capacities.plants[0];
    return firstPlant ? firstPlant.periods : [];
  }

  formatPeriod(period: PlantCapacityPeriod): string {
    return `${this.formatTime(period.timeFrom)}-${this.formatTime(period.timeTo)}`;
  }

  getLoadType(loadPercentage: number): 'success' | 'warning' | 'danger' {
    if(loadPercentage > 100)
      return 'danger';
    if(loadPercentage >= 85)
      return 'warning';
    return 'success';
  }

  getBarHeight(loadPercentage: number): number {
    return Math.min(100, Math.max(0, loadPercentage));
  }

  trackByPlantId(_index: number, plant: PlantCapacity): number {
    return plant.plant.id;
  }

  private formatTime(value: string): string {
    const [hour, minutes] = value.split(':');
    return minutes === '00' ? String(Number(hour)) : `${Number(hour)}:${minutes}`;
  }
}
